import { styled } from '@mui/material'
import MuiTextField from '@mui/material/TextField'
import { TextFieldProps } from './TextField.types'

export const TextField = styled(MuiTextField, {
  shouldForwardProp: (prop) => !['hideLabel'].includes(prop as string),
})<TextFieldProps>`
  .MuiInput-root {
    margin-bottom: 8px;
    :hover:not(.Mui-disabled)::before {
      border-bottom-width: 1px;
    }
  }

  .MuiInput-input {
    font-size: 16px;
    font-weight: 400;
  }

  .Mui-error .MuiInput-input {
    color: ${({ theme }) => theme.palette.error.main};
  }

  .MuiFormLabel-root {
    font-size: 16px;
    font-weight: 400;
  }

  .MuiFormHelperText-root {
    color: ${({ theme, error }) => theme.palette[error ? 'error' : 'info'].main};
    letter-spacing: -0.5px;
    font-size: 12px;
    line-height: 12px;
    margin: 0;
  }
`
